// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { sortCandidatesInContest } from "@sequentech/ui-core";
/**
 * The contests in the order the ballot shows them: by their configured
 * position, with the contests without one last. The ballot style lists them
 * in another order.
 */
export var sortContestsInBallotOrder = function (contests) {
    return __spreadArray([], contests, true).sort(function (a, b) { var _a, _b, _c, _d; return ((_b = (_a = a.presentation) === null || _a === void 0 ? void 0 : _a.sort_order) !== null && _b !== void 0 ? _b : Infinity) - ((_d = (_c = b.presentation) === null || _c === void 0 ? void 0 : _c.sort_order) !== null && _d !== void 0 ? _d : Infinity); });
};
/**
 * Candidates of a contest in the order the ballot shows them: its configured
 * candidate order, without shuffling a random one.
 */
export var sortCandidatesInBallotOrder = function (contest, candidates) {
    var _a;
    if (candidates.length < 2) {
        return candidates;
    }
    var sortedIds = sortCandidatesInContest(candidates, (_a = contest.presentation) === null || _a === void 0 ? void 0 : _a.candidates_order, false).map(function (candidate) { return candidate.id; });
    return sortedIds.flatMap(function (id) { var _a; return (_a = candidates.find(function (candidate) { return candidate.id === id; })) !== null && _a !== void 0 ? _a : []; });
};
